// src/systems/runLog.ts — lightweight run-event log for in-browser debugging.
// Usage: open browser console and call  window.rogueLog.copy()
// Paste the result here for debugging.

export type RunLogEntry = {
  ms: number; // ms since log was reset
  event: string;
  data: unknown;
};

let _start = Date.now();
const _entries: RunLogEntry[] = [];

export function logEvent(event: string, data: unknown): void {
  _entries.push({ ms: Date.now() - _start, event, data });
}

export function resetLog(): void {
  _entries.length = 0;
  _start = Date.now();
}

export function getLogEntries(): RunLogEntry[] {
  return _entries;
}

export function serializeLog(): string {
  return _entries
    .map((e) => `+${e.ms}ms  ${e.event}\n${JSON.stringify(e.data, null, 2)}`)
    .join('\n\n---\n\n');
}
